import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { AdminUsersPage } from "@/components/pages/AdminUsersPage";

export const Route = createFileRoute("/admin/users")({
  component: AdminUsers,
});

function AdminUsers() {
  return (
    <AppLayout>
      <AdminUsersPage />
    </AppLayout>
  );
}
